'use client'

import { initRum } from './rum'

// eslint-disable-next-line no-restricted-imports
export { glovoRum } from '@glovo/rum'

let isInitialized = false

export const initObservability = () => {
  if (isInitialized) {
    return
  }
  initRum()
  isInitialized = true
}

export { withErrorBoundary } from './rum/error-tracking/ErrorBoundary'

export { useErrorHandling } from './rum/error-tracking/use-error-handling'
